import { render, staticRenderFns } from "./LanguageList.vue?vue&type=template&id=39872e16&scoped=true"
import script from "./LanguageList.vue?vue&type=script&lang=js"
export * from "./LanguageList.vue?vue&type=script&lang=js"
import style0 from "./LanguageList.vue?vue&type=style&index=0&id=39872e16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39872e16",
  null
  
)

export default component.exports